<template>
  <div class="nf">
    <div class="nf__peel">🍌</div>
    <div class="nf__code">404</div>
    <h1 class="nf__title">Tu as glissé sur une peau de banane</h1>
    <p class="nf__text">Cette page n'existe pas (ou plus). Ça arrive, même aux meilleurs.</p>
    <div class="nf__cta">
      <BananaButton to="/" size="lg">Retour à l'accueil</BananaButton>
      <BananaButton to="/aleatoire" variant="outline" size="lg">🎲 Une blague au hasard</BananaButton>
    </div>
  </div>
</template>

<script>
import BananaButton from '@/components/ui/BananaButton.vue'

export default {
  name: 'NotFound',
  components: { BananaButton },
}
</script>

<style scoped>
.nf {
  min-height: 68vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
}
.nf__peel { font-size: 4.5rem; animation: slip 2.5s ease-in-out infinite; }
@keyframes slip { 25% { transform: rotate(-20deg) translateX(-10px); } 75% { transform: rotate(20deg) translateX(10px); } }
.nf__code {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: clamp(5rem, 18vw, 10rem);
  line-height: 0.9;
  color: var(--banana-500);
  -webkit-text-stroke: 3px var(--ink-900);
  margin: 4px 0;
}
.nf__title { font-size: clamp(1.6rem, 5vw, 2.4rem); margin-bottom: 8px; }
.nf__text { color: var(--text-soft); max-width: 440px; margin: 0 auto 28px; font-size: 1.05rem; }
.nf__cta { display: flex; gap: 14px; flex-wrap: wrap; justify-content: center; }
</style>
